<template>
	<a
		v-if="chatbotConfig && isLoggedIn && $route.name !== 'contactUs'"
		:href="chatbotConfig.contactUrl"
		class="chatbot-bubble d-none d-md-flex"
		rel="noopener noreferrer"
		:title="$t('global.contact')"
	>
		<img
			:src="chatbotConfig.imageUrl"
			alt="Contact"
			class="chatbot-bubble__avatar"
		/>
	</a>
</template>

<script>
import { getChatbotConfig } from '@/assets/js/common.js'

export default {
	name: 'ChatbotBubble',

	computed: {
		chatbotConfig() {
			return getChatbotConfig()
		},
		isLoggedIn() {
			return this.isLogged()
		}
	}
}
</script>

